import { render } from "./sip.vue?vue&type=template&id=e31952a4&scoped=true"
import script from "./sip.vue?vue&type=script&lang=js"
export * from "./sip.vue?vue&type=script&lang=js"

import "./sip.vue?vue&type=style&index=0&id=e31952a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e31952a4"]])

export default __exports__